import api from "../../../../../../service/api";

export const uploadSapUnpaidInvoices = async (formdata) => {
    const response = await api.post("tms/sap-unpaid-invoice/upload", formdata);

    return response.data;
};

export const getSapUnpaidInvoices = async (params = {}) => {
    const response = await api.get("tms/sap-unpaid-invoice/index", params)

    return response
}

export const getSapUnpaidInvoiceCompanies = async ({search = '', page = 1}) => {
    const response = await api.get('tms/sap-unpaid-invoice/companies',{
        search, page, per_page: 20
    })

    return response
}

export const generateSoa = async (payload = {}) => {
    const response = await api.postPdf('tms/sap-unpaid-invoice/generate-soa',payload)

    return response
}
